module.exports = __webpack_public_path__ + "63aa206977b33b9afc1fda92a514944d.pdf";